import { QueryState } from '../../../common/enums';
import { Nullable } from '../../../common/utils';
export interface IUpdateHomeTextState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const UpdateHomeTextEmptyState: IUpdateHomeTextState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
